import {h, Fragment} from "preact"
import { useFacets, useSelectedFiltersCount, useSort } from '@nosto/preact'
import Facet from './Facet'
import RangeFacet from './RangeFacet'
import Icon from './elements/Icon'
import { useEffect, useState, useRef } from 'preact/hooks'
import { sortOptions } from '../config'
import Select from './elements/Select'

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ${className}`}
            for="toggle-mobile-sidebar">
            {/* <Icon name="close" /> */}
            <div class="ns-category-page-mobile-close">✕</div>
        </label>
    )
}

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={lableFor}
            className={`ns-act-btn ns-act-btn-mobile-filter ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ${className}`}>
            <Icon name="filter" />
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function SideBar({ toggleId, lableFor }) {
    const { loading, facets } = useFacets()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const [active, setActive] = useState(false)

    const facetRef = useRef(null)

    useEffect(() => {
        function handleClickOutside(event) {
            if (event.target.getAttribute('for') === 'toggle-mobile-sidebar') {
                return
            }

            if (facetRef.current && !facetRef.current.contains(event.target)) {
                if (active) {
                    setTimeout(() => {
                        setActive(false)
                    }, 50)
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [active])

    const toggleActiveUpdated = () => {
        const activeFacets = document.querySelectorAll('.ns-sidebar-dropdown.ns-active')
        activeFacets.forEach((facetElement) => {
            if (facetElement !== facetRef.current) {
                facetElement.classList.remove('ns-active')
            }
        })
        setActive(!active)
    }

    function handleSortChange(value) {
        setSort(value)
    }

    const isMobile = window.innerWidth < 769

    const options = sortOptions.map((o) => ({ value: o.id, label: o.value.name }))

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100">
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    {isMobile && (
                        // <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline ns-p-4">

                        <ToggleSidebarButton />
                        // </div>
                    )}
                    <div class="ns-sidebar-menu">
                        <ul class="ns-sidebar-list ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map((facet) => {
                                switch (facet.type) {
                                    case 'terms':
                                        return <Facet facet={facet} />
                                    case 'stats':
                                        return <RangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                            {!isMobile && (
                                <li
                                    ref={facetRef}
                                    class={`ns-sidebar-dropdown ns-sorting-options ${
                                        active ? 'ns-active' : ''
                                    }`}>
                                    <a
                                        class="ns-sidebar-facet-title ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                                        href="javascript:void(0)"
                                        onClick={toggleActiveUpdated}>
                                        Sorter
                                    </a>
                                    <div class="ns-sidebar-submenu ns-d-none">
                                        <ul class="ns-sort-list ns-list-unstyled">
                                            {options.map((option) => (
                                                <li
                                                    class="ns-d-flex ns-align-items-center"
                                                    data-nosto-element="facet-setting"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        handleSortChange(option.value)
                                                        toggleActiveUpdated()
                                                    }}>
                                                    <label class={`ns-checkbox ns-d-block`}>
                                                        <span
                                                            class={`ns-count ns-d-inline-block ns-text-align-center ${
                                                                activeSort === option.value
                                                                    ? 'ns-font-bold'
                                                                    : ''
                                                            }`}>
                                                            {option.label}
                                                        </span>
                                                        <input
                                                            type="checkbox"
                                                            checked={activeSort === option.value}
                                                        />
                                                        <span class="ns-checkmark" />
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ''
    )
}
